export default __webpack_public_path__ + "70a401880602d35d207a2141a38e2ad3.png";